import React from 'react';
import LoadingIndicator from '../../../LoadingIndicator';
import StreamedList from '../../../StreamedList';
import { StreamType } from '../../../Stream';
import SmallGroupCard from '../../../SmallGroupCard';
import BiButton from '../../../biLogger/Components/BiButton';
import { BiEventType } from '../../../biLogger';
import s from '../../AddToGroupsPanel.scss';
var GroupsList = function (_a) {
    var groups = _a.groups, onGroupSelected = _a.onGroupSelected, isFetching = _a.isFetching, streamId = _a.streamId, scrollableWrapperClassName = _a.scrollableWrapperClassName;
    return (React.createElement(React.Fragment, null,
        React.createElement(StreamedList, { streamId: streamId, streamType: StreamType.WITH_OFFSET, className: s['list'], wrapperClassName: scrollableWrapperClassName, bottomedClassName: s['bottomed'] }, groups.map(function (group) { return (React.createElement(BiButton, { key: group.userId, className: s['card'], onClick: function () { return onGroupSelected(group); }, biData: {
                evid: BiEventType.ADD_TO_GROUP_SELECT,
                groupid: group.useridUuid,
            } },
            React.createElement(SmallGroupCard, { group: group }))); })),
        isFetching && React.createElement(LoadingIndicator, { view: "llama", className: s['loader'] })));
};
GroupsList.displayName = 'GroupsList';
export default GroupsList;
//# sourceMappingURL=GroupsList.js.map